/**
 * Styled Components - Created by jorge on 23/07/18.
 */
import styled from 'styled-components'
import AntdButton from 'antd/lib/button'
import {
  BLACK,
  RED,
  GRAY_DARK,
  BLUE,
  GREEN_DARK,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  DARKER_GRAY,
  WHITE
} from '../../theme/colors'
import Input from 'antd/lib/input/Input'
import Icon from 'antd/lib/icon'
import Badge from 'antd/lib/badge'

interface DivProps {
  bold?: boolean
  secondary?: boolean
}

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 35em;
`

export const Container = styled.div``

export const ViewContainer = styled.div`
  display: flex;
  align-items: center;
  color: #5f6062;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
  text-align: right;
  cursor: pointer;

  &:hover {
    color: #e61737;
  }
`
export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 64px;
  margin-top: 48px;
  padding-right: 34px;
  position: relative;
  @media (max-width: 768px) and (min-width: 320px) {
    align-items: center;
    margin-bottom: 24px;
    padding-right: 0px;
  }
`
export const ScreenTitle = styled.div`
  color: #5f6062;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
`
export const ButtonWrapper = styled.span`
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;

  .ant-btn-primary {
    background-color: #4a90e2;
    border-color: #4a90e2;
  }
  .ant-btn-primary:hover {
    background-color: #4a90e2;
    border-color: #4a90e2;
  }
`
export const Button = styled(AntdButton)`
  height: 40px;
  width: 93px;
`
export const OrderInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 42px;
  padding-right: 34px;

  @media (max-width: 658px) and (min-width: 320px) {
    display: block;
    padding-right: 0px;
  }
`
export const OrderDelivery = styled.div`
  @media (max-width: 963px) and (min-width: 659px) {
    width: 50%;
  }
`

export const DeliveryDate = styled.div`
  color: #5f6062;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
  margin-bottom: 25px;

  @media (max-width: 768px) and (min-width: 320px) {
    display: flex;
    justify-content: space-between;
  }
`
export const DeliveryInfo = styled.div`
  @media (max-width: 963px) and (min-width: 320px) {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
  }
`
export const DeliveryLabels = styled.div`
  color: #5f6062;
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
  width: 187px;
`
export const DeliveryLabel = styled.div`
  margin-bottom: 12px;
  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`
export const DeliveryData = styled.div`
  color: #5f6062;
  display: inline-block;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  margin-left: 60px;

  @media (max-width: 963px) and (min-width: 320px) {
    margin-left: 9%;
    width: 150px;
  }
`

export const DeliveryLabelSecondary = styled.div`
  margin-bottom: 12px;
  white-space: nowrap;
  @media (max-width: 768px) {
    white-space: normal;
    height: auto;
  }
`

export const FedexIcon = styled.img`
  max-width: 40px;
  object-fit: contain;
  margin-right: 5px;
  margin-bottom: 2px;
`

export const UpsIcon = styled.img`
  max-height: 21px;
  object-fit: contain;
  margin-right: 7px;
  margin-bottom: 2px;
`

interface InfoProps {
  tracking?: boolean
  redColor?: boolean
  savingPdf?: boolean
}

export const Info = styled.div`
  color: ${({ tracking }: InfoProps) => (tracking ? RED : GRAY_DARK)};
  height: 22px;
  margin-bottom: 12px;
  &.link {
    text-decoration: underline;
    &:hover {
      color: ${BLACK};
      cursor: pointer;
    }
  }
  &.ondemandLink {
    color: ${GREEN_DARK};
    text-decoration: underline;
    &:hover {
      color: ${BLACK};
      cursor: pointer;
    }
  }
  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`
export const OrderSummaryContainer = styled.div`
  width: 27%;
  font-size: 16px;
  margin-top: -10px;
  animation: fade-in-right 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right {
    0% {
      transform: translateX(5px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @media (max-width: 1375px) and (min-width: 659px) {
    width: 258px;
  }

  @media (max-width: 658px) and (min-width: 320px) {
    margin-top: 50px;
    width: 100%;
  }
`
export const Items = styled.div`
  margin-top: 20px;
  padding-right: 34px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  @media (max-width: 658px) and (min-width: 320px) {
    padding-right: 0px;
  }
`

export const OpenIcon = styled(Icon)`
  margin-left: 8px;
  transform: scaleX(-1);
  font-size: 12px;
`

export const NetsuiteContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  align-items: center;
`

export const CartItem = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  max-width: 672px;
  width: 100%;
  @media (max-width: 698px) {
    flex-flow: column;
  }
`

export const ThumbnailImage = styled.img`
  width: 168px;
  height: 148px;
  object-fit: cover;
  background: ${GRAY_LIGHTEST};
  border-radius: 3px;
  @media (max-width: 680px) {
    width: 98px;
    height: 98px;
  }
`

export const ItemInfo = styled.div`
  margin-left: 32px;
  @media (max-width: 680px) {
    margin-left: 20px;
  }
`

export const DescriptionLabel = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
`

export const DesignDescription = styled.div`
  max-width: 460px;
  width: 100%;
  margin-top: 28px;
  position: absolute;
  @media (max-width: 680px) {
    position: unset;
  }
`

export const TaxDiv = styled.div``

export const TaxPercent = styled.div`
  margin-left: 10px;
  font-size: 12px;
  color: ${DARKER_GRAY};
  display: inline-block;
`

export const DesignInfo = styled.div`
  margin-bottom: 6px;
`

export const DesignCode = styled.div`
  text-decoration: underline;
  color: ${BLUE};
  &:hover {
    cursor: pointer;
  }
`

export const PriceLabel = styled.div`
  flex: 1;
  text-align: right;
  font-weight: bold;
  font-size: 16px;
  margin-right: 32px;
  @media (max-width: 698px) {
    font-size: 16px;
    margin-left: 18px;
    margin-right: unset;
    text-align: left;
  }
`

export const NetsuiteTitle = styled.div``

export const NetsuiteValue = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
`

export const StyledInput = styled(Input)`
  border-radius: 0;
  width: 90px;
  height: 20px;
  font-size: 12px;
  .ant-input {
    border-radius: 0;
  }
`

export const NetsuiteLeft = styled.div``

export const NetsuiteRight = styled.div`
  display: flex;
  align-items: center;
`

export const UpsertButton = styled.div`
  margin-left: 8px;
  font-size: 12px;
  color: red;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
`

export const TitleStyled = styled.div`
  color: #5f6062;
  display: flex;
  font-size: 16px;
  font-weight: 600;
  justify-content: space-between;
  line-height: 22px;
  margin-bottom: 24px;
`
export const CartList = styled.ul`
  padding: 0;
  max-width: 782px;
  width: 100%;
`
export const ShippingBillingContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 40px 10% 36px 0;

  @media (max-width: 658px) and (min-width: 320px) {
    flex-wrap: wrap;
    margin-right: 0px;
  }
`
export const ShippingBillingCard = styled.div`
  margin-right: 158px;
  @media (max-width: 658px) and (min-width: 320px) {
    margin-right: 5px;
  }
`

export const DataOrder = styled.div`
  margin-right: 22px;
  @media (max-width: 1024px) {
    margin-right: 8px;
    margin-left: 8px;
  }
`

export const SubTitle = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 24px;
`
export const StyledImage = styled.img`
  margin-left: 8px;
  width: 42px;
  height: 25.5px;
`
export const Date = styled.span`
  margin-left: 5px;
`

export const BadgeStyled = styled(Badge)`
  .ant-badge-count {
    font-size: 12px;
    left: -2px;
    right: auto;
    top: -7px;
    padding: 0px 5px;
    height: 17px;
    line-height: 18px;
  }
`

export const NoteDiv = styled.div`
  display: flex;
  flex-flow: column;
  font-size: 10px;
  line-height: normal;
  color: ${RED};
  margin-left: 8px;
`

export const NoteIcon = styled(Icon)`
  color: ${BLUE};
  font-size: 25px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

export const InvoiceDiv = styled.div`
  margin-bottom: 40px;
`

export const InvoiceTitle = styled.div`
  font-weight: 900;
  font-size: 16px;
  margin-bottom: 12px;
  font-family: Avenir-Medium;
`

export const InvoiceSubtitle = styled.div`
  font-weight: bold;
  margin-bottom: 12px;
`

export const InvoiceIcon = styled(Icon)`
  margin-right: 8px;
  color: ${BLUE};
`

export const DownloadInvoice = styled.div`
  position: absolute;
  right: 152px;
  top: 0;
  border: 1px solid ${RED};
  color: ${RED};
  padding: 5px 12px;
  text-align: center;
  height: 27px;
  font-size: 12px;
  border-radius: 3px;
  min-width: 143.38px;
  transition: all .25s;
  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }
`

export const DownloadIcon = styled(Icon)`
  margin-right: 10px;
`

export const SavingContainer = styled.div`
  position: absolute;
  width: 100%;
  background: #ffffffc9;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  z-index: 29;
`

export const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const RefundReference = styled.div`
  margin-top: 12px;
  max-width: 348px;
`

export const RefundLink = styled.a`
  color: ${BLUE};
  font-size: 13px;
`

export const DirectLogo = styled.img`
  height: 22px;
  margin-bottom: 12px;
  margin-left: 8px;
`

export const SummaryTitle = styled.div`
  font-weight: bold;
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
`

export const TotalLabel = styled.div`
  font-weight: ${({ bold }: DivProps) => bold ? 'bold' : 'unset'};
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
  padding-bottom: ${({ secondary }: DivProps) => secondary ? 'unset' : '14px'};
  border-bottom: ${({ secondary }: DivProps) => secondary ? 'unset' : `1px solid ${GRAY_LIGHT}`};
  &:last-child {
    border-bottom: none;
  }
`

export const PriceDiv = styled.div``

export const PayNow = styled.a`
  color: ${WHITE} !important;
  background: #8dd251;
  padding: 4px 18px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: bold;
  font-family: Avenir;
  box-shadow: -1px 2px 3px -1px #858585;
  transition: all .25s;
  &:hover {
    opacity: 0.8;
  }
`

export const InfoSecondary = styled.div`
  color: ${({ redColor }: InfoProps) => redColor ? RED : GRAY_DARK};
  height: 22px;
  margin-bottom: 12px;
  white-space: nowrap;
  @media (max-width: 940px) {
    white-space: normal;
  }
  @media (max-width: 768px) {
    text-align: ${({ savingPdf }: InfoProps) => savingPdf ? 'left' : 'right'};
    margin-bottom: 16px;
    height: auto;
  }
`

export const FedexLabel = styled.div`
  color: ${BLUE};
  text-decoration: underline;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
`

export const ServiceImageContainer = styled.div`
  width: 168px;
  height: 148px;
  background: ${GRAY_LIGHTEST};
  border-radius: 5px;
  padding: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 698px) {
    width: 128px;
    height: 118px;
    margin-bottom: 12px;
  }
`

export const ServiceImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  opacity: 0.8;
`

export const TopMobileSection = styled.div`
  display: flex;
  justify-content: space-between;
`

export const OrderIcon = styled(Icon)`
  color: #5eb1cb;
  margin-bottom: 3px;
  margin-right: 12px;
`

export const PaymentLink = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #8782ff;
  border-radius: 5px;
  padding: 9px 0;
  padding-top: 6px;
`

export const StripeIcon = styled.img`
  max-width: 58px;
`

export const CheckDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #c17899;
  border-radius: 5px;
  padding: 18px 0;
  color: #91687b;
`

export const CheckIcon = styled(Icon)`
  margin-right: 8px;
  color: #c17899;
`

export const SummaryContainer = styled.div`
  box-shadow: 1px 2px 4px 0px #dddddd;
  padding: 13px 16px;
  border-radius: 5px;
  border-top: 1px solid #f1f1f1;
  padding-bottom: 1px;
`

export const InvoiceLink = styled.div`
  width: fit-content;
  display: flex;
  margin-top: 25px;
  justify-content: flex-start;
  align-items: center;
  color: ${BLUE};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    i {
      color: ${RED} !important;
    }
    color: ${RED} !important;
    text-decoration: underline;
  }
`

export const FlagIcon = styled.img`
  max-width: 22px;
  margin-top: -3px;
  border-radius: 3px;
`

export const CategoryLabel = styled.div`
  font-weight: normal;
  font-size: 14px;
  margin-top: 8px;
  color: #828282;
`

export const QuantityLabel = styled.div`
  font-weight: normal;
  font-size: 14px;
  margin-top: 6px;
  color: #828282;
`

export const FilesSection = styled.div`
  margin-top: 22px;
`

export const FilesList = styled.div``

export const FileClip = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
`

export const Clip = styled(Icon)`
  color: ${RED};
  margin-right: 12px;
`

export const FileName = styled.div`
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${BLUE};
  transition: all .25s;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

export const ImportedLabel = styled.div`
  font-size: 12px;
  font-family: Avenir;
  position: absolute;
  top: -26px;
`

export const ImportedIcon = styled(Icon)`
  font-size: 10px;
  margin-right: 6px;
  transform: rotate(-90deg);
  background: white;
  color: #7c61b4;
  border-radius: 25px;
  padding: 4px;
  border: 1px solid #e4dbf5;
  box-shadow: none;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/OrderServiceDetails/styledComponents.tsx